import Image from 'next/image';
import React from 'react';

import buyBackGuarantee from '@/assets/images/buyBackGuarantee.svg';
import competitiveExchangeRates from '@/assets/images/competitiveExchangeRates.svg';
import lockInRate from '@/assets/images/lockInRate.svg';
import secureShield from '@/assets/images/secureShield.svg';

const BuyReason = () => {
  return (
    <section className="home__tab">
      <div className="reason-tab-content bg bg--light">
        <div className="tab-pane active container">
          <h2 className="text--black text--bold section__title-small step-text text-center">
            Reasons to Buy Forex from Us
          </h2>
          <div className="row">
            <div className="col-lg">
              <div className="tab__card__container">
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="30 minutes door step service"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">100%</span> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={competitiveExchangeRates}
                      alt="lowest interest rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Competitive</span> exchange
                      rates
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={lockInRate}
                      alt="lowest interest rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Lock-in</span> your exchange
                      rate
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={buyBackGuarantee}
                      alt="gold rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Buy-back</span> <br />{' '}
                      guarantee
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BuyReason;
